import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const ECommissionType = {
	noCommission: 'NO_COMMISSION',
	percent: 'PERCENT',
	fixed: 'FIXED',
} as const;

export type TCommissionType = TValueOfStringRecord<typeof ECommissionType>

export const ECommissionDate = {
	today: 'TODAY',
	startFromDate: 'START_FROM_DATE',
} as const;

export type TCommissionDate = TValueOfStringRecord<typeof ECommissionDate>
